import { useQueryClient } from '@tanstack/react-query';
import type { ProgramUserRsvp } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getTodosInfiniteQueryKey } from 'features/todos/queries/use-todos-query';
import { updateEventUserStatus } from '../../services';
import { getEventDetailQueryKey, getEventsInviteesInfiniteQueryKey, getEventsQueryKey } from '../keys';

export const useUpdateEventUserStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { id: string; statusToApply: ProgramUserRsvp }>({
    async mutationFn({ id, statusToApply }) {
      const response = await updateEventUserStatus(id, statusToApply);
      return response.data;
    },

    async onSettled(_, __, params) {
      await queryClient.invalidateQueries({ queryKey: getEventsQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getTodosInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getEventDetailQueryKey({ id: params.id }) });
      await queryClient.invalidateQueries({ queryKey: getEventsInviteesInfiniteQueryKey({}) });
    },
  });
};
